<template>
  <v-dialog
    retain-focus
    :value="create"
    v-on:click:outside="$router.push('/customer')"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Create Customer</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['Customer/fetchCustomers']({ page: this.page });
              $router.push('/customer');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            label="Customer Name*"
            v-model="createFields.name"
            :rules="validationRules.name"
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveCustomer"
            name="name"
            index="1"
          ></v-text-field>
          <v-text-field
            label="Address"
            v-model="createFields.address"
            :rules="validationRules.address"
            :error-messages="inputErrorMessages('address')"
            name="address"
          ></v-text-field>
          <v-text-field
            label="Contact Numbers"
            v-model="createFields.contact_numbers"
            :rules="validationRules.contact_numbers"
            :error-messages="inputErrorMessages('contact_numbers')"
            name="contact_numbers"
          ></v-text-field>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/customer');
            clearCreate();
            $refs.createForm.resetValidation();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveCustomer">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Customer name'),
          v => !v || v.length <= 255 || 'Customer name should not be greater than 255'
        ],
        address: [v => !v || v.length <= 255 || 'Address should not be greater than 255'],
        contact_numbers: [
          v => !v || v.length <= 255 || 'Contact numbers should not be greater than 255'
        ]
      },
      errorMessages: {},
      createFields: {
        name: '',
        address: '',
        contact_numbers: ''
      }
    };
  },
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions(['Customer/fetchCustomers']),
    clearCreate() {
      this.createFields = {
        name: '',
        address: '',
        contact_numbers: ''
      };
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveCustomer() {
      if (this.$refs.createForm.validate()) {
        axios
          .post('api/v1/customer', this.createFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Customer created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.clearCreate();
            this.$refs.createForm.resetValidation();
            this['Customer/fetchCustomers']({ page: this.page });
            if (this.continousCreation === false) {
              this.$router.push('/customer');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    }
  }
};
</script>